import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, computed, watch } from 'vue';

import GenericButton from './GenericButton.vue';
import FrkFlexContainer from './FrkFlexContainer.vue';
import FrkHelpIcon from './FrkHelpIcon.vue';

type Props = {
  name: string;
  hideCloseButton?: boolean;
  startingFromBottom?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'FrkModal',
  props: {
    name: null,
    hideCloseButton: { type: Boolean, default: false },
    startingFromBottom: { type: Boolean, default: false }
  },
  emits: ['closed'],
  setup(__props: any, { emit }) {

const props = __props as { name: string, hideCloseButton: boolean, startingFromBottom: boolean };

const $modal = getCurrentInstance()!.proxy.$modal;
const $slots = getCurrentInstance()!.proxy.$slots;



const isVisible = computed(() => $modal.currentModal === props.name);
const currentModal = computed(() => $modal.currentModal);

const roundedBorderClass = computed(() => ($slots.foot ? '' : 'tw-rounded-b-xl'));



watch(currentModal, async (value, oldValue) => {
  if (value === props.name) {
    show();
  } else if (oldValue === props.name) {
    emit('closed');
  }
});

function show() {
  window.addEventListener('keyup', ev => {
    if (ev.key === 'Escape' && isVisible) {
      $modal.hide();
    }
  });
}

return { __sfc: true,$modal, $slots, props, isVisible, currentModal, roundedBorderClass, emit, show, GenericButton, FrkFlexContainer, FrkHelpIcon }
}

})